import { InjectionToken } from '@angular/core';

/**
 * Opens the host's own support entry from the failed-uploads window. Optional: without a provider the
 * window opens the shared support channel menu (`SupportChannelMenuService`).
 */
export const UPLOAD_SUPPORT_CONTACT = new InjectionToken<() => void>('UPLOAD_SUPPORT_CONTACT');
